// src/components/event/FloatingHearts.jsx
import React from 'react'

const FloatingHearts = () => {
    return (
        <div className="pointer-events-none fixed inset-0 -z-10">
            <span className="absolute left-[10%] top-[25%] h-10 w-10 animate-heartFloat rounded-full bg-rose-400/30 blur-xl" />
            <span className="absolute right-[12%] top-[30%] h-12 w-12 animate-heartFloatSlow rounded-full bg-pink-300/35 blur-xl" />
            <span className="absolute left-[18%] bottom-[18%] h-9 w-9 animate-heartFloatDelay rounded-full bg-amber-200/40 blur-xl" />
        </div>
    )
}

export default FloatingHearts
